/**
 * Show OS / PWA notifications for incoming tester chat messages.
 */

export async function ensureNotificationPermission() {
  if (typeof window === 'undefined' || !('Notification' in window)) {
    return 'unsupported';
  }
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  try {
    const result = await Notification.requestPermission();
    return result;
  } catch {
    return 'denied';
  }
}

export async function showChatOsNotification({ title, body, tag, url = '/app/messages' }) {
  if (typeof window === 'undefined' || !('Notification' in window)) return false;
  if (Notification.permission !== 'granted') return false;

  const options = {
    body: body || 'You have a new support message',
    icon: '/images/icon-192.png',
    badge: '/images/icon-192.png',
    tag: tag || 'testgate-chat',
    renotify: true,
    data: { url },
  };

  try {
    if ('serviceWorker' in navigator) {
      const reg = await navigator.serviceWorker.ready;
      if (reg?.showNotification) {
        await reg.showNotification(title || 'TestGate Support', options);
        return true;
      }
    }
  } catch {
    // fall through to page Notification
  }

  try {
    const n = new Notification(title || 'TestGate Support', options);
    n.onclick = () => {
      window.focus();
      if (url) window.location.href = url;
      n.close();
    };
    return true;
  } catch {
    return false;
  }
}
